export default {"src":"/_next/static/media/payment-unionpay-icon.a71587a3.svg","height":20,"width":29};